export default __webpack_public_path__ + "static/media/actionServo.3f806ec0.svg";